function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "2421E11F-7446-4DFE-87EB-BFFFC4E0F0A9");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Permatrol",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Responsive_1",
  transform: "translate(-16.000000, -2368.000000)",
  fill: "#22252D"
}, React.createElement("g", {
  id: "Group-14",
  transform: "translate(11.000000, 2278.000000)"
}, React.createElement("path", {
  d: "M20,90 C20.5522847,90 21,90.4477153 21,91 L21,101 C21,101.552285 20.5522847,102 20,102 L6,102 C5.44771525,102 5,101.552285 5,101 L5,91 C5,90.4477153 5.44771525,90 6,90 L20,90 Z M19.0038342,93.1195876 L13.0126585,98.2049701 L7.02148278,93.1195876 L7.02148278,99.8768057 L19.0038342,99.8768057 L19.0038342,93.1195876 Z M18.0600615,91.9581814 L7.95251466,91.9581814 L13,96 L18.0600615,91.9581814 Z",
  id: "correo"
}))));

var SvgFtEmail = function SvgFtEmail(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "16px",
    height: "12px",
    viewBox: "0 0 16 12",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFtEmail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ft-email.cf3b4ce7.svg";
export { ForwardRef as ReactComponent };